(function ($, window, document) {
    $(document).ready(function () {
        var pollInterval = 5000;
        var pollTimer = null;
        var pollRequest = null;
        var pollingStopped = false;
        var $notice = $("[data-stale-login-notice]");
        var $noticeMessage = $("[data-stale-login-message]");
        var $loginForm = $("#login-form");
        var $currentLoginHeader = $("[data-current-login-header]");
        var $currentLoginPanel = $("[data-current-login-panel]");
        var loginStatusUrl = $notice.attr("data-login-status-url");

        if (!$notice.length || !$currentLoginPanel.length || !loginStatusUrl) {
            return;
        }

        function setCurrentLoginPanelDisabled(isDisabled) {
            $currentLoginPanel
                .find("input, button, select, textarea")
                .prop("disabled", isDisabled);
        }

        function getStaleLoginMessage(loginState) {
            return typeof loginState.email === "string" && loginState.email.length
                ? "You're now logged in as " + loginState.email
                : "You're now logged in";
        }

        function showStaleLoginNotice(loginState) {
            setCurrentLoginPanelDisabled(true);
            $("#new-user").hide();
            $loginForm.show().addClass("stale-login-active");
            $currentLoginHeader.hide();
            $currentLoginPanel.hide();
            $noticeMessage.text(getStaleLoginMessage(loginState));
            $notice.removeAttr("hidden").attr("aria-hidden", "false").show();
        }

        function restoreCurrentLoginPanel() {
            setCurrentLoginPanelDisabled(false);
            $loginForm.removeClass("stale-login-active");
            $notice.attr("hidden", "hidden").attr("aria-hidden", "true").hide();
            $currentLoginHeader.show();
            $currentLoginPanel.show();
        }

        function handleLoginState(loginState) {
            if (!loginState || typeof loginState.isAuthenticated !== "boolean") {
                return;
            }

            if (loginState.isAuthenticated) {
                showStaleLoginNotice(loginState);
            }
            else {
                restoreCurrentLoginPanel();
            }
        }

        function scheduleLoginStatusCheck() {
            window.clearTimeout(pollTimer);

            if (pollingStopped) {
                return;
            }

            pollTimer = window.setTimeout(checkLoginStatus, pollInterval);
        }

        function checkLoginStatus() {
            window.clearTimeout(pollTimer);

            if (pollingStopped || pollRequest) {
                return;
            }

            if (document.visibilityState === "hidden") {
                scheduleLoginStatusCheck();
                return;
            }

            pollRequest = $.ajax({
                url: loginStatusUrl,
                dataType: "json",
                cache: false
            })
                .done(handleLoginState)
                .always(function () {
                    pollRequest = null;
                    scheduleLoginStatusCheck();
                });
        }

        function stopLoginStatusChecks() {
            pollingStopped = true;
            window.clearTimeout(pollTimer);

            if (pollRequest) {
                pollRequest.abort();
                pollRequest = null;
            }
        }

        $currentLoginPanel.find("form").on("submit", stopLoginStatusChecks);
        $(window).on("focus pageshow", checkLoginStatus);
        $(document).on("visibilitychange", function () {
            if (document.visibilityState !== "hidden") {
                checkLoginStatus();
            }
        });

        checkLoginStatus();
    });
})(jQuery, window, document);